import * as firebase from 'firebase'
export default {
  /**
   * Uses fb auth to create a new user, then subsequently
   * creates a user in firebase realtime data base in order to
   * hold user's data not associated with authentication.
   */
  signUp ({commit, dispatch, state}, payload) {
    commit('setLoading', true, {root: true})
    firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
      .then(
        response => {
          let user = response.user
          commit('setLoading', false, {root: true})
          dispatch('sendEmailVerification')
          // create user in realtime database
          dispatch('saveState', {
            id: user.uid,
            email: user.email,
            displayName: payload.displayName
          })
        }
      )
      .catch(
        error => {
          commit('setLoading', false, {root: true})
          commit('setError', error, {root: true})
        }
      )
  },
  /**
   * Logs user in via fb authentication, then reaches out
   * to the fb realtime datatbase to fetch users data
   */
  signIn ({commit, dispatch}, payload) {
    commit('setLoading', true, {root: true})
    firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
      .then(
        response => {
          commit('setLoading', false, {root: true})
          // auth state has changed, so listener will be fired from main.js,
          // to fetch user data
        }
      )
      .catch(
        error => {
          commit('setLoading', false, {root: true})
          commit('setError', error, {root: true})
        }
      )
  },
  // Pulls data from fb, updates local state
  fetchState ({commit}, id) {
    commit('setLoading', true, {root: true})
    firebase.database().ref('/users/' + id).once('value')
      .then((response) => {
        commit('setLoading', false, {root: true})
        commit('updateUser', response.val(), {root: true})
      })
      .catch((error) => {
        commit('setLoading', false, {root: true})
        commit('setError', error, {root: true})
      })
  },
  // Updates any fields within payload on the database,
  // id is required
  saveState ({commit, state}, payload) {
    if (!payload.id) { console.error('id required to update user data!') }
    commit('setLoading', true, {root: true})
    firebase.database().ref('/users/' + payload.id).update(payload)
      .then((response) => {
        commit('setLoading', false, {root: true})
        commit('setUnsavedData', false)
      })
      .catch((error) => {
        commit('setLoading', false, {root: true})
        commit('setError', error, {root: true})
      })
  },
  /**
   * Logs the user out and destroys local user state
   */
  logout ({commit}) {
    firebase.auth().signOut()
    commit('unsetUser', {}, {root: true})
  },
  /**
   * Sends an email to the user asking them to verify their email
   */
  sendEmailVerification ({commit}) {
    const user = firebase.auth().currentUser // current user should be set already
    user.sendEmailVerification().then(() => {
      console.log('Verification email sent to ' + user.email)
    }).catch((error) => console.error(error))
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js